/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/* @flow */
function consumeEvent(e: Event) {
  e.preventDefault();
  if (typeof e.target.blur === 'function') {
    e.target.blur();
  }
}

export { consumeEvent };
